import { render } from "./MusicAlbumListing.vue?vue&type=template&id=3479c8c8&scoped=true"
import script from "./MusicAlbumListing.vue?vue&type=script&lang=ts"
export * from "./MusicAlbumListing.vue?vue&type=script&lang=ts"

import "./MusicAlbumListing.vue?vue&type=style&index=0&id=3479c8c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3479c8c8"

export default script